<template>
  <q-fila v-if="aplica" :label="label" :ayuda="ayuda" :completa="respondida" :resaltar="resaltar">
    <input type="time" class="form-control" :value="value" :disabled="soloLectura"
           @input="$emit('input', $event.target.value || null)" />
  </q-fila>
</template>

<script>
import QFila from "./QFila";

/** Hora "HH:mm", con el input nativo que ya usaban las fichas anteriores. */
export default {
  name: "QHora",
  components: { QFila },
  props: {
    value: { default: null },
    label: { type: String, required: true },
    ayuda: { type: String, default: "" },
    aplica: { type: Boolean, default: true },
    resaltar: { type: Boolean, default: true },
    soloLectura: { type: Boolean, default: false },
  },
  computed: {
    respondida() {
      return this.value != null && String(this.value).trim().length > 0;
    },
  },
};
</script>
